var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 33,
    height: 33,
    rx: 4,
    fill: "url(#paint0_linear_1589_49917)",
    fillOpacity: 0.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 24,
    height: 34,
    rx: 2,
    fill: "#F4F4F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 7,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 10,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 13,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 18,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2452C0 24.4212 0.505307 23.6816 1.27288 23.382L30.2729 12.0643C31.5843 11.5525 33 12.5197 33 13.9274V34C33 35.1046 32.1046 36 31 36H2C0.895431 36 0 35.1046 0 34V25.2452Z",
    fill: "#9200FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.945 34.13C12.7917 34.13 12.6617 34.0767 12.555 33.97C12.4517 33.8633 12.4 33.7333 12.4 33.58C12.4 33.43 12.4517 33.3017 12.555 33.195C12.6617 33.0883 12.7917 33.035 12.945 33.035C13.0983 33.035 13.2283 33.0883 13.335 33.195C13.4417 33.3017 13.495 33.43 13.495 33.58C13.495 33.7333 13.4417 33.8633 13.335 33.97C13.2283 34.0767 13.0983 34.13 12.945 34.13ZM14.6996 34V27H17.1096C17.4863 27 17.8263 27.0933 18.1296 27.28C18.4363 27.4667 18.6796 27.7183 18.8596 28.035C19.0429 28.3517 19.1346 28.7017 19.1346 29.085C19.1346 29.475 19.0413 29.8283 18.8546 30.145C18.6713 30.4583 18.4263 30.7083 18.1196 30.895C17.8129 31.0817 17.4763 31.175 17.1096 31.175H15.7396V34H14.6996ZM15.7396 30.135H17.0046C17.2046 30.135 17.3863 30.085 17.5496 29.985C17.7163 29.885 17.8479 29.7517 17.9446 29.585C18.0446 29.4183 18.0946 29.23 18.0946 29.02C18.0946 28.81 18.0446 28.6217 17.9446 28.455C17.8479 28.285 17.7163 28.1517 17.5496 28.055C17.3863 27.955 17.2046 27.905 17.0046 27.905H15.7396V30.135ZM20.0902 34V27H22.4052C22.8886 27 23.3419 27.0917 23.7652 27.275C24.1886 27.455 24.5602 27.7067 24.8802 28.03C25.2002 28.35 25.4502 28.7217 25.6302 29.145C25.8136 29.565 25.9052 30.0167 25.9052 30.5C25.9052 30.9833 25.8136 31.4367 25.6302 31.86C25.4502 32.28 25.2002 32.6517 24.8802 32.975C24.5602 33.295 24.1886 33.5467 23.7652 33.73C23.3419 33.91 22.8886 34 22.4052 34H20.0902ZM21.1302 32.96H22.4052C22.7452 32.96 23.0619 32.8967 23.3552 32.77C23.6519 32.6433 23.9136 32.4667 24.1402 32.24C24.3702 32.0133 24.5486 31.7517 24.6752 31.455C24.8019 31.1583 24.8652 30.84 24.8652 30.5C24.8652 30.16 24.8019 29.8417 24.6752 29.545C24.5486 29.2483 24.3702 28.9867 24.1402 28.76C23.9136 28.5333 23.6519 28.3567 23.3552 28.23C23.0619 28.1033 22.7452 28.04 22.4052 28.04H21.1302V32.96ZM26.7602 34V27H30.8852V28.04H27.8002V29.73H30.4052V30.77H27.8002V34H26.7602Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1589_49917",
    x1: 1.5,
    y1: 3,
    x2: 31,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9200FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570098"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.151ec52538b2643b3192327cbd51855b.svg";
export { ForwardRef as ReactComponent };